import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clientLogger } from './logger';
import Error from '../components/AppError';

class ErrorBoundary extends Component {
  state = {
    hasError: false
  };

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(err) {
    if (
      typeof this.props.fptiImpression === 'function' &&
      typeof window !== undefined
    ) {
      const feedback = window.feedback || {}; // use existing global fpti data used by feedback component
      this.props.fptiImpression({
        ...feedback,
        erpg: `App Error in error boundary: ${err.message}`,
        eccd: 'code'
      });
    }
    clientLogger.error('React Component Error: handled in ErrorBoundary', err);
  }

  render() {
    if (this.state.hasError && this.props.renderFallback !== false) {
      return <Error />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  renderFallback: PropTypes.bool,
  fptiImpression: PropTypes.func
};

const wrapErrorBoundary = (Component, renderFallback) => props => (
  <ErrorBoundary renderFallback={renderFallback}>
    <Component {...props} />
  </ErrorBoundary>
);

export default ErrorBoundary;

export { wrapErrorBoundary };
